import { isEmpty } from 'lodash-es';
import { useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';

const LOCALSTORAGE_KEY = 'weave.operatory-v3-ff-override';
const FF_NAME = 'scheduler-v3-ui-operatory';

const useFFOverride = () => {
  const [isSchedulerV3FFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  return { isOverrideFF: !!isSchedulerV3FFOverride };
};

export const useGetV3OperatoryFeatureFlagDetails = () => {
  const { isOverrideFF } = useFFOverride();
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);

  const { getFeatureFlagValue, getFeatureFlagLocationMap } = useScopedAppFlagStore();

  const operatoryV3FFLocationMap = getFeatureFlagLocationMap(FF_NAME);

  // NOTE: Remove this temporary check(isFeatureFlagsLoaded) later once this logic added into `getFeatureFlagValue` method
  const hasFF = isFeatureFlagsLoaded && getFeatureFlagValue(FF_NAME, 'ALL');

  return {
    operatoryV3FFLocationMap,
    isOperatoryV3FlagEnabled: hasFF || isOverrideFF,
    isLoading: !isFeatureFlagsLoaded,
  };
};
